"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCallout = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyledCallout = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledCallout",
  componentId: "sc-10wktk7-0"
})(["padding:15px;font-size:14px;border:1px solid ", ";border-radius:4px;background-color:", ";p{margin-bottom:5px;&:last-of-type{margin-bottom:0;}}"], function (props) {
  return props.themeColor;
}, function (props) {
  return (0, _tinycolor["default"])(props.themeColor).setAlpha(0.05).toRgbString();
});

exports.StyledCallout = StyledCallout;